import { cssClass, Style } from './StyleFunctions';

export const flexRowStyle: Style = {
  display: 'flex',
  flexDirection: 'row',
};

export const flexColumnStyle: Style = {
  display: 'flex',
  flexDirection: 'column',
};

export const elideTextStyle: Style = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
};

export const elideTextClass = cssClass('elideText', elideTextStyle);

export const absolutePositionFillStyle: Style = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
};

export const absolutePositionFill = cssClass(`absolute-position-fill`, absolutePositionFillStyle);
